"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerAttributes = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
const general_1 = require("../../general");
const userHelpers_1 = require("../../userHelpers");
/**
 * Gets common session variables from `context` and `sessionAPI` and
 * applies precedence rules defined in this function.
 *
 * DEFINITION: `context` is in this utility is a plain object containing
 * external attributes (eg. cookies, middleware, etc.)
 *
 *
 * @param {SessionApiResponse} session
 * @param {ContextAttributes} context
 * @returns {SessionAttributesType} - session data
 */
const getCustomerAttributes = (session, context) => {
    var _a, _b;
    const cookieCredit = (0, get_1.default)(context, 'credit');
    const correlationId = (0, get_1.default)(context, 'correlationId');
    const oAuth2Token = (0, get_1.default)(context, 'oauth2token');
    // session vars override cookies
    const rawSession = (0, get_1.default)(session, 'koodo');
    const currentBan = (0, get_1.default)(rawSession, 'account.ban');
    const currentSub = (0, get_1.default)(rawSession, 'subscriber.phoneNumber');
    const isAuthed = !(0, isEmpty_1.default)(currentBan) || !(0, isEmpty_1.default)(oAuth2Token);
    const isSod = (0, get_1.default)(rawSession, 'isSod');
    const account = (0, get_1.default)(rawSession, 'account', {});
    const subscriber = (0, get_1.default)(rawSession, 'subscriber', {});
    const activationSalesTransactionId = (0, get_1.default)(context, 'activationSalesTransactionId');
    const sessionSalesTransactionId = rawSession === null || rawSession === void 0 ? void 0 : rawSession.salesTransactionId;
    const salesTransactionId = (_a = sessionSalesTransactionId !== null && sessionSalesTransactionId !== void 0 ? sessionSalesTransactionId : activationSalesTransactionId) !== null && _a !== void 0 ? _a : (0, general_1.getGuidOrGenerate)(null);
    let creditClass = (0, get_1.default)(rawSession, 'creditClass');
    if ((0, isEmpty_1.default)(creditClass)) {
        creditClass = cookieCredit;
    }
    if ((0, isEmpty_1.default)(creditClass)) {
        creditClass = 'B';
    }
    const sessionOrderType = (0, get_1.default)(rawSession, 'orderType', undefined);
    const orderType = (0, userHelpers_1.getOrderTypeOrDefault)(sessionOrderType);
    const loginIncomplete = (0, get_1.default)(rawSession, 'errors.loginIncomplete', false);
    const lang = (_b = (0, get_1.default)(context, 'lang')) !== null && _b !== void 0 ? _b : (0, userHelpers_1.getDefaultLang)();
    // Takes in full session object with koodo key
    const prov = (0, userHelpers_1.getProvince)(session, orderType, context);
    const sessionAttributes = {
        lang,
        prov,
        correlationId,
        currentBan,
        currentSub,
        creditClass,
        orderType,
        salesTransactionId,
        isAuthed,
        account,
        subscriber,
        loginIncomplete,
        isSod
    };
    return (0, general_1.removeUndefined)(sessionAttributes);
};
exports.getCustomerAttributes = getCustomerAttributes;
exports.default = exports.getCustomerAttributes;
//# sourceMappingURL=getCustomerAttributes.js.map